/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Card/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import Radial from 'DesignSystem/Radial/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Card({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/PaymentsTreatmentPlan/Content/TreatmentPayments/Content/Content/SetupPayment/ActiveStep/DownpaymentSetup/Pay/ChooseType/Card"
  
}) {
let payersActivetabDownpaymentMetadataTypeValueData = fromData.useDataValue({ viewPath,
context: 'payers',
path: 'activeTab.downpayment_metadata.type',
})
let constantData = 'card'
let aggregateData = fromAggregate.equals(payersActivetabDownpaymentMetadataTypeValueData, constantData)
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="Card.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Radial
  viewPath={`${viewPath}/Radial`}
 data="payers.activeTab.downpayment_metadata.type"
 data="'card'"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData}
 onClick={onClick}
 marginRight={0}
 paddingRight={0}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={0}
 text="Credit card"
/>
</div>
{children}
</React.Fragment>)
}